import { Outlet, useLocation } from "react-router-dom";
import { AdminSidebar } from "../components/admin/AdminSidebar";
import { AdminTopBar } from "../components/admin/AdminTopBar";
import { NAV_ITEMS } from "../components/admin/navItems";

export default function AdminLayout() {
  const location = useLocation();
  const current =
    NAV_ITEMS.filter((n) => location.pathname === n.to || (n.to !== "/admin" && location.pathname.startsWith(n.to))).sort((a, b) => b.to.length - a.to.length)[0] ||
    NAV_ITEMS[0];

  return (
    <div className="min-h-screen bg-clean-white flex" data-testid="admin-layout">
      <AdminSidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <AdminTopBar title={current.label} />
        <main className="flex-1 p-4 sm:p-8" data-testid="admin-main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
